import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { toChild } from '../../../../api';
import { ApiDataResponse } from '../../../../api/types/response';
import { Nullable } from '../../../../utils/types';

export const useMakeChild = (strategyId: string, onSuccess?: () => void) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSuccessCb = (result: Pick<ApiDataResponse<unknown>, 'success' | 'errorMessage'>) => {
    if (!result.success) {
      enqueueSnackbar(result.errorMessage || 'Ошибка', { variant: 'error' });
      return;
    }
    enqueueSnackbar('Стратегия переведена в дочернюю');
    onSuccess?.();
  };

  const onError = (e: unknown) => {
    enqueueSnackbar(String(e), { variant: 'error' });
  };

  const mutation = useMutation({
    mutationFn: (vars: { parentId: string; useSignals: boolean }) =>
      toChild({ strategyId, parentStrategyId: vars.parentId, useSelfSignals: vars.useSignals }),
    onSuccess: onSuccessCb,
    onError,
  });

  const makeChildOfHandler = (id: Nullable<string>, useSignals: boolean) => {
    if (!id) return;
    mutation.mutate({ parentId: id, useSignals });
  };

  return { loading: mutation.isPending, makeChildOfHandler };
};
